'use client'

import { useSKUSelectionStore } from '@src/stores/SKUSelectionStore'
import { cn } from '@src/utils/tailwind'

export const SKUSelectionRailItemBorder = ({
  columnsDesktop,
  railSlug,
  sku,
}: {
  columnsDesktop?: number
  railSlug?: string
  sku?: string
}) => {
  const group = useSKUSelectionStore((state) => state.groups.get(railSlug ?? ''))
  const isSelected = sku ? (group?.includes(sku) ?? false) : false

  return (
    <div
      className={cn(
        'absolute -inset-1 rounded-[14px] hover:outline hover:outline-[3px] hover:outline-bodi-black-text lg:rounded-[30px]',
        {
          'ring ring-bodi-green-deep-500  hover:outline-bodi-green-deep-500': isSelected,
        },
        { 'lg:rounded-[14px]': (columnsDesktop ?? 0) >= 5 }
      )}
    ></div>
  )
}
